module.exports = __webpack_public_path__ + "img/1sb_Serta_sheep_img_mob.19fc029.svg";